import { render } from "./JsonDialog.vue?vue&type=template&id=0a8d637a"
import script from "./JsonDialog.vue?vue&type=script&lang=js"
export * from "./JsonDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__